import React from 'react'

import validation from '../../../validation'
import PhoneInput from '../../controls/PhoneInput'
import ProviderAutocomplete from '../../ProviderAutocomplete'

function Component({ caseModel, createInputProps, setModelValue, ErrorMessage }) {
  const handleProviderSelect = provider => {
    if (!provider) return
    // Search returns ProviderSummaryItem, not ProviderDto:
    //   provider.organization = company/practice name
    //   provider.name         = individual physician name (empty for org-only results)
    //   provider.phone / .email = contact details
    if (provider.organization) setModelValue('physicianReviewer.companyName', provider.organization)
    if (provider.name?.trim()) setModelValue('physicianReviewer.name', provider.name.trim())
    if (provider.phone) setModelValue('physicianReviewer.contact.phone', provider.phone)
    if (provider.email) setModelValue('physicianReviewer.contact.email', provider.email)
  }

  return (
    <div>
      <h3 className="pb-3">Physician Reviewer</h3>
      <p className="text-muted">
        The independent physician (or IME company representative) who will review the case and answer the clinical
        questions prepared by the case manager.
      </p>

      <div className="form-group">
        <label className="form-label">Quick-fill from IME Provider Library</label>
        <ProviderAutocomplete
          type="IME"
          value={caseModel.physicianReviewer?.companyName || ''}
          onChange={val => setModelValue('physicianReviewer.companyName', val)}
          onProviderSelect={handleProviderSelect}
          placeholder="Search IME providers..."
        />
        <small className="form-text text-muted">
          Select a provider to pre-fill contact details. All fields remain editable.
        </small>
      </div>

      <div className="form-row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="physicianReviewer.name">
              Physician Name
            </label>
            <input
              type="text"
              {...createInputProps('physicianReviewer.name')}
              className="form-control"
              maxLength={validation.maxLengths.name}
              placeholder="Dr. Jane Smith"
            />
            <ErrorMessage name="physicianReviewer.name" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="physicianReviewer.companyName">
              IME Company / Organization
            </label>
            <input
              type="text"
              {...createInputProps('physicianReviewer.companyName')}
              className="form-control"
              maxLength={validation.maxLengths.name}
              placeholder="Acme IME Associates"
            />
            <ErrorMessage name="physicianReviewer.companyName" />
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="physicianReviewer.specialization">
              Specialization
            </label>
            <input
              type="text"
              {...createInputProps('physicianReviewer.specialization')}
              className="form-control"
              placeholder="e.g. Orthopedic Surgery, Neurology"
            />
            <ErrorMessage name="physicianReviewer.specialization" />
          </div>
        </div>
      </div>

      <hr />
      <h5 className="form-heading mb-3">Contact</h5>
      <div className="form-row">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="physicianReviewer.contact.phone">
              Phone
            </label>
            <PhoneInput
              {...createInputProps('physicianReviewer.contact.phone')}
              className="form-control"
              placeholder="(123) 456-7890"
            />
            <ErrorMessage name="physicianReviewer.contact.phone" />
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="physicianReviewer.contact.fax">
              Fax
            </label>
            <PhoneInput
              {...createInputProps('physicianReviewer.contact.fax')}
              className="form-control"
              placeholder="(123) 456-7890"
            />
            <ErrorMessage name="physicianReviewer.contact.fax" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label mt-2" htmlFor="physicianReviewer.contact.email">
              Email
            </label>
            <input
              type="email"
              {...createInputProps('physicianReviewer.contact.email')}
              className="form-control"
              placeholder="reviewer@ime-company.com"
              maxLength={validation.maxLengths.email}
            />
            <ErrorMessage name="physicianReviewer.contact.email" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default {
  name: 'Physician Reviewer',
  group: 'Providers',
  visibleForCaseTypes: ['ColoradoRule16'],
  validationSchema: validation.object({}),
  Component,
}
